import { NEWS_META } from '@/content/site';
import { TextLink } from '@/components/ActionButton';
import { ButtonLink } from '@/components/Button';
import { EmptyState } from '@/components/Controls';
import { Section } from '@/components/Section';
import { Seo } from '@/components/Seo';

const MAIN_ROUTES: readonly { label: string; to: string }[] = [
  { label: '首页', to: '/' },
  { label: '平台能力', to: '/platform' },
  { label: '解决方案', to: '/solutions' },
  { label: '方案与定价', to: '/pricing' },
  { label: '动态', to: '/news' },
  { label: '关于我们', to: '/about' },
  { label: '联系我们', to: '/contact' },
];

export function NotFoundPage() {
  return (
    <>
      <Seo path="/404" title="页面不存在 — Havorix™" description="这个地址对应不到任何页面。" />

      <Section spacing="loose">
        <div className="mx-auto flex max-w-3xl flex-col gap-8">
          <EmptyState
            title="该地址暂无内容"
            text="可能是链接有误，或页面已调整位置。以下为全站主要入口。"
            actions={
              <div className="flex flex-wrap gap-3">
                <ButtonLink to="/" variant="primary">
                  返回首页
                </ButtonLink>
                <ButtonLink to="/platform" variant="secondary">
                  了解平台能力
                </ButtonLink>
              </div>
            }
          />

          <div className="flex flex-wrap gap-x-6 gap-y-3">
            {MAIN_ROUTES.map((route) => (
              <TextLink key={route.to} to={route.to}>
                {route.label}
              </TextLink>
            ))}
          </div>

          <div>
            <span className="label-mono">最近的工程笔记</span>
            <ul className="mt-3 space-y-2">
              {NEWS_META.slice(0, 3).map((item) => (
                <li key={item.slug}>
                  <TextLink to={`/news/${item.slug}`}>{item.title}</TextLink>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </Section>
    </>
  );
}
